import { motion } from 'framer-motion';
import styled from 'styled-components';

import { mediaTablet } from 'utils/styles/responsive';

export const MediaSliderWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const MediaSliderBox = styled.div`
  height: 100%;
`;

export const MediaSliderStyled = styled(motion.div)<{
  gap: number;
  slides: number;
}>`
  height: 100%;

  display: inline-grid;
  grid-template-columns: ${({ slides }) => `repeat(${slides}, 80vw)`};

  ${({ slides }) =>
    mediaTablet(`grid-template-columns: repeat(${slides}, 50vh);`)}

  gap: ${({ gap }) => gap}px;
`;

export const ComponentWrapper = styled.div`
  height: 100%;
  aspect-ratio: 1/1;
  width: 100%;

  * {
    pointer-events: none;
  }
`;

export const DotsWrapper = styled.div`
  margin-bottom: 48px;
  display: inline-flex;
  gap: 8px;
`;
export const Dot = styled.button<{ isActive: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 100%;
  border: none;

  background: ${({ theme }) => theme.colors.white};

  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
`;
